module.exports = __webpack_public_path__ + "fb2054a97968e2f9ab04292953f4aad1.MP3";